import { render, staticRenderFns } from "./MonteReservation.vue?vue&type=template&id=98a572ba&"
import script from "./MonteReservation.vue?vue&type=script&lang=js&"
export * from "./MonteReservation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports